import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
import i18n from './plugins/i18n'
import mitt from 'mitt'
import { setupCalendar } from 'v-calendar'
import 'v-calendar/style.css'
import VueGoogleMaps from '@fawmi/vue-google-maps'

const emitter = mitt()
const app = createApp(App)

app.use(vuetify)
app.use(router)
app.use(store)
app.use(i18n)
app.use(setupCalendar, {})
app.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyC4_1TJqe4PU3BnhoNkE8AGTSxGZxHmZ5A',
    libraries: 'places,marker',
    v: '3.56',
    async: true,
    defer: true,
    loading: 'async'
  }
})


app.provide('bus', emitter)

// Set language based on user location
const userLang = navigator.language || navigator.userLanguage
const langCode = userLang.split('-')[0]
const supportedLangs = ['pt', 'en', 'fr', 'de']
const defaultLang = supportedLangs.includes(langCode) ? langCode : 'pt'
i18n.global.locale = defaultLang

store.dispatch('fetchYearList')

app.mount('#app')

export const bus = emitter